import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LibraryBugIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23 12.25H19.75V7.31L22.53 4.53C22.82 4.24 22.82 3.76 22.53 3.47C22.24 3.18 21.76 3.18 21.47 3.47L18.69 6.25H16.75V5C16.75 2.38 14.62 0.25 12 0.25C9.38 0.25 7.25 2.38 7.25 5V6.25H5.31L2.53 3.47C2.24 3.18 1.76 3.18 1.47 3.47C1.18 3.76 1.18 4.24 1.47 4.53L4.25 7.31V12.25H1C0.59 12.25 0.25 12.59 0.25 13C0.25 13.41 0.59 13.75 1 13.75H4.25V16C4.25 17.09 4.48 18.12 4.88 19.06L1.97 21.97C1.68 22.26 1.68 22.74 1.97 23.03C2.26 23.32 2.74 23.32 3.03 23.03L5.64 20.42C7.04 22.43 9.37 23.75 12 23.75C14.63 23.75 16.96 22.43 18.36 20.42L20.97 23.03C21.26 23.32 21.74 23.32 22.03 23.03C22.32 22.74 22.32 22.26 22.03 21.97L19.12 19.06C19.52 18.12 19.75 17.09 19.75 16V13.75H23C23.41 13.75 23.75 13.41 23.75 13C23.75 12.59 23.41 12.25 23 12.25ZM8.75 5C8.75 3.21 10.21 1.75 12 1.75C13.79 1.75 15.25 3.21 15.25 5V6.25H8.75V5ZM18.25 16C18.25 19.19 15.84 21.83 12.75 22.2V10C12.75 9.59 12.41 9.25 12 9.25C11.59 9.25 11.25 9.59 11.25 10V22.2C8.16 21.83 5.75 19.19 5.75 16V7.75H18.25V16Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

LibraryBugIcon.displayName = 'LibraryBugIcon';
